export default __webpack_public_path__ + "static/media/icon-star.be7c0356.svg";